/* export function tlv2String(tlvBuffer) {
  const typeBuffer = new Uint8Array(tlvBuffer, 0, 4)
  const lengthBuffer = new Uint8Array(tlvBuffer, 4, 4)
  const valueBuffer = new Uint8Array(tlvBuffer, 8)

  let type = '';
  for (let i = 0; i < typeBuffer.length; i++) {
    type += String.fromCharCode(typeBuffer[i]);
  }

  const length =
    (lengthBuffer[0] << 24) | (lengthBuffer[1] << 16) | (lengthBuffer[2] << 8) | lengthBuffer[3];

  const value = new TextDecoder().decode(valueBuffer.subarray(0, length));

  return { type, value };
}
 */
export function tlv2String(tlvBuffer) {
  const typeBuffer = new Uint8Array(tlvBuffer, 0, 4);
  const lengthBuffer = new Uint8Array(tlvBuffer, 4, 4);
  const valueBuffer = new Uint8Array(tlvBuffer, 8);

  // 提取 Type
  let type = '';
  for (let i = 0; i < typeBuffer.length; i++) {
    type += String.fromCharCode(typeBuffer[i]);
  }

  // 提取 Length
  const length =
    (lengthBuffer[0] << 24) | (lengthBuffer[1] << 16) | (lengthBuffer[2] << 8) | lengthBuffer[3];

  // 确保 Length 对齐到多字节字符边界（假设 UTF-8 编码）
  const alignedLength = Math.ceil(length / 3) * 3;

  // 提取 Value
  const value = new TextDecoder('utf-8').decode(valueBuffer.subarray(0, alignedLength));

  return { type, value };
}